import {
  VALID_CA_PROVINCE_CODES,
  VALID_US_STATE_CODES,
  VALID_US_TERRITORY_CODES,
} from "../formats/state";

const REGION_CODES = new Set<string>([
  ...VALID_US_STATE_CODES,
  ...VALID_US_TERRITORY_CODES,
  ...VALID_CA_PROVINCE_CODES,
]);

const POSTAL_CODE = String.raw`(?:\d{5}(?:-\d{4})?|[A-Za-z]\d[A-Za-z][\s-]?\d[A-Za-z]\d)`;

const LEAD_IN = String.raw`(?:\s+[-–—]+\s*|(\p{L}|")[-–—]+\s*|\s+in\s+)`;

const CITY_CHAR = String.raw`[\p{L}\p{M}0-9.'’&-]`;
const CITY_START = String.raw`[\p{L}\p{M}0-9]`;
const CITY = `((?:${CITY_START}${CITY_CHAR}*\\s+)*${CITY_START}${CITY_CHAR}+)`;

const SOURCE_LOCATION_WITH_POSTAL = new RegExp(
  `${LEAD_IN}${CITY},?\\s+([A-Z]{2})\\s+${POSTAL_CODE}\\s*$`,
  "u",
);

const SOURCE_LOCATION_WITHOUT_POSTAL = new RegExp(
  `${LEAD_IN}${CITY},\\s+([A-Z]{2})\\s*$`,
  "u",
);

export function stripProductSourceLocation(name: string): string {
  return [SOURCE_LOCATION_WITH_POSTAL, SOURCE_LOCATION_WITHOUT_POSTAL]
    .reduce(
      (current, pattern) =>
        current.replace(pattern, (match, keptChar, _city, region) =>
          REGION_CODES.has(region) ? keptChar || "" : match,
        ),
      name,
    )
    .trim();
}

export function splitProductSourceLocation(name: string): {
  base: string;
  location: string;
} {
  const base = stripProductSourceLocation(name);
  return { base, location: name.trim().slice(base.length) };
}
